"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = SubscriptionDetailsLoading;

var _react = _interopRequireDefault(require("react"));

var _commonReact = require("@devsta/common-react");

require("../styles/_subscription-loading.scss");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function getSubscriptionLoadingBlock(_ref) {
  var title = _ref.title;
  return _react.default.createElement(_commonReact.Form.TitledFormBlock, {
    title: title
  }, _react.default.createElement(_commonReact.ContentLoader, {
    height: 90,
    width: 580
  }, _react.default.createElement("rect", {
    x: "0",
    y: "0",
    rx: "0",
    ry: "0",
    width: "90",
    height: "90"
  }), _react.default.createElement("rect", {
    x: "115",
    y: "15",
    rx: "4",
    ry: "4",
    width: "175",
    height: "20"
  }), _react.default.createElement("rect", {
    x: "115",
    y: "45",
    rx: "4",
    ry: "4",
    width: "245",
    height: "10"
  }), _react.default.createElement("rect", {
    x: "115",
    y: "58",
    rx: "4",
    ry: "4",
    width: "245",
    height: "10"
  }), _react.default.createElement("rect", {
    x: "424",
    y: "28",
    rx: "4",
    ry: "4",
    width: "155",
    height: "35"
  })));
}

function SubscriptionDetailsLoading() {
  return _react.default.createElement("div", {
    className: "subscription-loading"
  }, getSubscriptionLoadingBlock({
    title: 'Subscription Package*'
  }), _react.default.createElement("hr", null), getSubscriptionLoadingBlock({
    title: 'Account Manager*'
  }), getSubscriptionLoadingBlock({
    title: 'Business Development Manager*'
  }), getSubscriptionLoadingBlock({
    title: 'Editing Team*'
  }));
}